import superAgent from 'superagent';
import LocStorage from '../LocalStorage';
import superAgentIntercept from 'superagent-intercept';

let ErrorIntercept;

export function passHistoryToSuperagentIntercept(history) {
    ErrorIntercept = superAgentIntercept((err, res) => {
        if (err) {
            if (err.status === 401 || err.status === 403) {
                LocStorage.removeToken('token');
                LocStorage.removeToken('refresh_token');
                history.push('/login');
            }
        }
    });
}

export const getRequest = route => {
    return new Promise((resolve, reject) => {
        superAgent
            .get(route)
            .use(ErrorIntercept)
            .set({ Authorization: 'Bearer ' + LocStorage.getToken('token'), 'Accept-Language': LocStorage.getFromStorage('lang') })
            .then(response => resolve(response))
            .catch(error => reject(error.response));
    });
};

export const postRequest = (route, details) => {
    return new Promise((resolve, reject) => {
        superAgent
            .post(route)
            .use(ErrorIntercept)
            .set({
                Authorization: 'Bearer ' + LocStorage.getToken('token'),
                'Content-Type': 'application/json',
                'Accept-Language': LocStorage.getFromStorage('lang')
            })
            .send(details)
            .then(response => resolve(response))
            .catch(error => reject(error.response));
    });
};

export const putRequest = (route, details) => {
    return new Promise((resolve, reject) => {
        superAgent
            .put(route)
            .use(ErrorIntercept)
            .set({
                Authorization: 'Bearer ' + LocStorage.getToken('token'),
                'Content-Type': 'application/json',
                'Accept-Language': LocStorage.getFromStorage('lang')
            })
            .send(details)
            .then(response => resolve(response))
            .catch(error => reject(error.response));
    });
};

export const deleteRequest = (route) => {
    return new Promise((resolve, reject) => {
        superAgent
            .delete(route)
            .use(ErrorIntercept)
            .set({
                Authorization: 'Bearer ' + LocStorage.getToken('token'),
                'Content-Type': 'application/json',
                'Accept-Language': LocStorage.getFromStorage('lang')
            })
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

export const postRequestCreatePassword = (route, token, details) => {
    return new Promise((resolve, reject) => {
        superAgent
            .post(route)
            .use(ErrorIntercept)
            .set({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept-Language': LocStorage.getFromStorage('lang')
            })
            .send(details)
            .then(response => resolve(response))
            .catch(error => reject(error.response));
    });
};

export const postRequestEditPassword = (route, details) => {
    return new Promise((resolve, reject) => {
        superAgent
            .post(route)
            .use(ErrorIntercept)
            .set({
                'Accept-Language': LocStorage.getFromStorage('lang')
            })
            .send(details)
            .then(response => resolve(response))
            .catch(error => reject(error.response));
    });
};

export const getGeoRequest = route => {
    return new Promise((resolve, reject) => {
        superAgent
            .get(route)
            .use(ErrorIntercept)
            .then(response => {
                if (response.body.results && response.body.results[0]) {
                    resolve(response.body.results[0].geometry.location)
                } else {
                    resolve('no results')
                }
            })
            .catch(error => reject(error));
    });
};



// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-requests.js